<template>
  <div class="page-wrapper">
    <div class="mb16 error-color ">温馨提示：①页面数据作为经营参考，不作为结算依据②预计每天8点更新前一天数据③空置指标只展示所选周期最后1天的数据④环比为-1表示上期数据为0</div>
    <seach-list class="mb16"
                @getdata="getData2"
    ></seach-list>
    <div class="cards">

      <Row  :gutter="12" class="cards">
        <Col v-for="(item,i) in cards" style="min-width:260px"  :key="'keyA'+i" span="12" :md="8" :lg="6">
          <card class="card" :data="item"  :key="'keyA'+i"></card>
        </Col>
      </Row>
      <!--<card class="card" :data="item" v-for="(item,index) in cards" :key="'keyA'+index"></card>-->
    </div>
    <check-in-ratio
      :projectInfos="projectInfos"
      :checkinList="checkinList"
      class="mb8"
    ></check-in-ratio>
    <div class=" flex others">
      <section class="unoccupied flexauto" >
        <unoccupied-and-realesae
          :vacancyValue="vacancyValue"
          :statusValue="statusValue"
          :surrenderData="surrenderData"
          :surrenderRate="surrenderRateData"
        ></unoccupied-and-realesae>
      </section>
      <section class="transfer flexauto">
        <transfer :transferData="transferData"></transfer>
      </section>
    </div>
  </div>
</template>

<script>
  import SeachList from '../components/SearchList'
  import {indexCards, sortCheckinRate, vacancyDays,
    funnelConversionRate,surrenderRate,checkinRateList
  } from "../../../api/reporter";
  import Card from './components/Cards'
  import CheckInRatio from './components/CheckInRatio'
  import UnoccupiedAndRealesae from './components/UnoccupiedAndRealesae'
  import Transfer from './components/Transfer'
  import {getProjects} from "../../../api/common";
  import {formatDateTime} from "../../../utils/format";

  export default {
    name: "operationindex",
    components: {
      SeachList,
      Card,
      CheckInRatio,
      UnoccupiedAndRealesae,
      Transfer
    },
    created() {
      // this.init()

    },
    data() {
      return {
        projectInfos: [],
        vacancyValue: [],
        statusValue: [],
        searchData: null,
        cards:[],
        checkinList:[],
        surrenderData:[],
        transferData:[],
        surrenderRateData:null
      }

    },
    methods: {
      checkinRateList(){
        checkinRateList(this.searchData).then(res=>{
          if(!res.data){
            return

          }
          this.checkinList=res.data.rows
        }).catch(()=>{return})
      },
      surrenderRate(){
        surrenderRate(this.searchData).then(res=>{
          if(!res.data){
            return
          }
          this.surrenderData=res.data.surrenderRateDetail
          this.surrenderRateData=res.data.surrenderRate
        }).catch(()=>{
          return
        })

      },
      funnelConversionRate(){
        funnelConversionRate(this.searchData).then(res=>{
          if(!res.data){
            return
          }
          res.data.info && ( this.transferData=res.data.info  )
        }).catch(error=>{})

      },
      getData2(params){
        this.searchData=params
        this.getData()

      },
      getData(){

        this.indexCards()  //首页小卡片接口
        this.vacancyDays() //空置天数
        this.sortCheckinRate()  //入住率排名
        this.surrenderRate()  //解约率
        this.funnelConversionRate() //转化漏斗率
        this.checkinRateList()  //入住率列表

      },

      // init() {
      //   let ret = {
      //     projectFids: [],
      //     type: 0,
      //     startTime: '',
      //     endTime: ''
      //   }
      //   let p1=getProjects().then(res => {
      //     if (!res.data) {
      //       return
      //     }
      //     res.data.length > 0 && (ret.projectFids = [res.data[0].value])
      //   }).catch(error => {
      //   }).finally(()=>{
      //     let date = new Date()
      //     let year = date.getFullYear()
      //     let month = date.getMonth()
      //     let day = date.getDate()
      //     ret.startTime = formatDateTime(new Date(year, month, day - 7), false)
      //     ret.endTime = formatDateTime(new Date(year, month, day - 1), false)
      //     this.searchData=ret
      //
      //     this.getData()
      //
      //   })
      //
      //
      //
      //
      // },
      vacancyDays() {
        vacancyDays(this.searchData).then(res => {
          if(!res.data){
            return
          }
          res.data.vacancyValue  && (   this.vacancyValue = res.data.vacancyValue  )
          res.data.statusValue && ( this.statusValue = res.data.statusValue  )

        }).catch(error => {
        })

      },
      indexCards() {
        indexCards(this.searchData).then(res=>{
          this.cards=res.data

        }).catch(error=>{})
      },
      sortCheckinRate() {
        sortCheckinRate(this.searchData).then(res => {
          if(!res.data){
            return
          }
          this.projectInfos = res.data.projectInfos
        }).catch(error => {})

      }

    }
  }
</script>

<style scoped>
  .cards {
    display: flex;
    flex-wrap: wrap;

  }

  .card {
    margin: 0 16px 16px 0;
    flex: none;
  }

  .others {
    /*height: 415px;*/
  }

  .unoccupied {
    flex: 0.6;
    margin-right: 20px;
    /*background-color: lightsteelblue;*/
  }

  .transfer {
    /*height: 100%;*/
    /*width: 40%;*/
    flex: 0.4;
  }


</style>
